import React from 'react';
import { useTranslation } from 'react-i18next';
import BlockTabs from '../BlockTabs';
import { Loader } from '../components';
import { useGetPublisherDataByDayQuery } from '../../api/publisherApiSlice';
import ChartContainer from '../metrics/DataByDayChart';
import TableContainer from '../metrics/TableContainer';

export default function DeviceDataByDay ( {publisherId, startDate, endDate} ) {
	const { t } = useTranslation();
  const {data = [], isSuccess, isLoading, refetch} = useGetPublisherDataByDayQuery({publisherId, startDate, endDate})

  const loaderProps = { success: (!isLoading && isSuccess), error: (!isLoading && !isSuccess), retry: refetch }
  return (
    <BlockTabs title={t("dataByDay.title")} defaultActiveKey="chart">
      <Loader {...loaderProps} key="table" title="table">
        <TableContainer data={data} />
      </Loader>
      <Loader {...loaderProps} key="chart" title="chart" >
        <ChartContainer data={data} />
      </Loader>
    </BlockTabs>
  )
}
